const uz = {
    meta: {
        title: "Excel o'rniga ERP tizimi: 8 ta signal va narx | Innobek",
        description:
            "Excel o'rniga ERP tizimi qachon kerak: kompaniya jadvalni o'sib ketganini ko'rsatadigan 8 ta signal, har birining pul bahosi, ERP narxi va joriy etish muddati.",
        keywords: [
            "Excel o'rniga ERP tizimi",
            "ERP tizimi nima uchun kerak",
            "ERP joriy etish bosqichlari",
            "ombor va ishlab chiqarish hisobi dasturi",
            "1C o'rniga o'z tizimi",
            "ERP narxi O'zbekiston",
        ],
    },
    h1: "Excel'dan ERP'ga: kompaniya jadvalni o'sib ketganini ko'rsatadigan 8 ta signal",
    lead:
        "Excel yomon vosita emas — u shunchaki ma'lum hajmdan keyin ishlamay qo'yadi. Bu maqolada o'sha chegarani ko'rsatadigan sakkizta signal, har birining oylik pul bahosi va ERP joriy etish narxi hamda muddati keltirilgan.",
    category: "Avtomatlashtirish",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Hech bir kompaniya «bugundan Excel yetmaydi» degan kunni aniq belgilay olmaydi. O'tish sekin sodir bo'ladi: avval bitta fayl ikkitaga bo'linadi, keyin har bo'limda o'z nusxasi paydo bo'ladi, keyin esa hech kim qaysi nusxa to'g'ri ekanini bilmay qoladi. Quyidagi sakkizta signal shu jarayonning bosqichlari.",
        },

        { type: "h2", text: "Excel qachongacha yetadi?" },
        {
            type: "p",
            text:
                "Excel bitta odam bitta faylda ishlaganda ajoyib ishlaydi. Muammo bir vaqtda bir necha kishi ishlay boshlaganda va ma'lumot o'zaro bog'langanda boshlanadi: ombor qoldig'i sotuvga, sotuv moliyaga, moliya esa ishlab chiqarishga bog'liq bo'ladi.",
        },
        {
            type: "p",
            text:
                "Jadvalda bu bog'liqliklar odam yodida saqlanadi. Odam ta'tilga chiqsa, kasal bo'lsa yoki ishdan ketsa, bog'liqlik ham yo'qoladi. ERP — bu bog'liqliklarni dasturga ko'chirish. Boshqacha aytganda, ERP hisobni yaxshilamaydi, u hisobni odamga bog'liq bo'lmagan holga keltiradi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Birinchi to'rt signal: hisob buzila boshlagan" },
        {
            type: "list",
            items: [
                "Signal 1. Ombor qoldig'i real bilan mos kelmaydi. Jadvalda 40 dona turibdi, javonda 33 tasi. Inventarizatsiya har safar kamomad ko'rsatadi va sababi topilmaydi.",
                "Signal 2. Oy yopilishi bir haftadan ko'p vaqt oladi. Buxgalteriya oyning 10–15-kunigacha o'tgan oy raqamini yig'adi, rahbar esa eskirgan ma'lumot asosida qaror qabul qiladi.",
                "Signal 3. Bir xil ma'lumot uch joyda saqlanadi. Mijoz ismi CRM'da, buyurtmasi Excel'da, to'lovi 1C'da. Uchtasi bir-biriga mos kelmasa, qaysi biri to'g'riligini hech kim isbotlay olmaydi.",
                "Signal 4. Buyurtma bekor qilinishi tez-tez uchraydi. Mijozga «bor» deb aytiladi, keyin omborda yo'qligi ma'lum bo'ladi. Har bunday holat bitta bitimni va bitta mijozni yo'qotadi.",
            ],
        },
        {
            type: "p",
            text:
                "Bu to'rttasining umumiy sababi bitta: ma'lumot bir nechta nusxada yashaydi va ular o'rtasida avtomatik bog'liqlik yo'q. Qo'lda sinxronlash esa doimo kechikadi.",
        },

        { type: "h2", text: "Keyingi to'rt signal: boshqaruv va qonun talablari" },
        {
            type: "list",
            items: [
                "Signal 5. Xodim ketganda fayl yoki bilim yo'qoladi. «Bu jadvalni Dilnoza yuritardi» degan jumla eshitilsa, tizim odamda saqlanayotgan bo'ladi.",
                "Signal 6. Narx va shartlar tarixi yo'q. Mijoz olti oy oldingi narxni eslatsa, uni tekshirib bo'lmaydi. Bahs har doim kompaniya zarariga hal bo'ladi.",
                "Signal 7. Hisobotni faqat bitta odam tayyorlay oladi. U band bo'lsa, rahbar raqamsiz qoladi. Bu signal ko'pincha e'tiborsiz qoladi, lekin eng xavflisi.",
                "Signal 8. Markirovka va elektron hisob-faktura qo'lda kiritiladi. Har chek va har hujjat uchun qo'lda ish — bu vaqt sarfi va bir vaqtda soliq riski.",
            ],
        },
        {
            type: "p",
            text:
                "Oxirgi signal 2026-yilda alohida vazn oldi. PP-190 (23.05.2025) bo'yicha 1-iyuldan markirovka qilingan tovar sotilganda kod onlayn-KKM chekida aks etishi shart, ulgurji savdoda hisob-kitob esa faqat naqdsiz, bank hisob raqamlari orqali amalga oshiriladi. 1-sentyabrdan markirovka qoidalarini buzish «yuqori» soliq riski omili hisoblanadi. Elektron hisob-faktura ustidan avtomatik nazorat ham kuchaytirildi.",
        },
        {
            type: "callout",
            text:
                "Uchtasi to'g'ri kelsa — jarayonni tartibga solish vaqti keldi. Beshtasi to'g'ri kelsa — Excel endi hisob vositasi emas, xavf manbayi.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Har signalning pul bahosi qancha?" },
        {
            type: "p",
            text:
                "Signal o'zi hech narsani anglatmaydi — uni pulga aylantirish kerak. Quyidagi jadvalda model kompaniya olingan: ulgurji savdo, 25 xodim, oyiga 400 buyurtma, o'rtacha chek 4 mln so'm, marja 15 foiz, soat tannarxi 45–50 ming so'm.",
        },
        {
            type: "table",
            head: ["Signal", "Qanday o'lchanadi", "Model kompaniyada oyiga"],
            rows: [
                [
                    "Bekor qilingan buyurtma",
                    "Qoldiq xatosi tufayli bekor bo'lgan buyurtma × o'rtacha chek × marja",
                    "12 × 4 mln × 15% ≈ 7,2 mln so'm",
                ],
                [
                    "Oy yopilishi cho'zilgan",
                    "Yopishga ketgan soat × soat tannarxi",
                    "80 soat × 50 000 ≈ 4 mln so'm",
                ],
                [
                    "Bir ma'lumot uch joyda",
                    "Qayta kiritishga ketgan soat × soat tannarxi",
                    "66 soat × 45 000 ≈ 3 mln so'm",
                ],
                [
                    "Markirovka va ESF qo'lda",
                    "Qo'lda kiritish soati × soat tannarxi, ustiga soliq riski",
                    "44 soat × 45 000 ≈ 2 mln so'm",
                ],
                [
                    "Ombor kamomadi",
                    "Oxirgi inventarizatsiya akti bo'yicha kamomad ÷ 12",
                    "O'z aktingizdan oling",
                ],
                [
                    "Hisobot bitta odamda",
                    "Qaror kechikkan kunlar soni",
                    "Odatda 5–10 kun, pulda o'lchanmaydi",
                ],
            ],
        },
        {
            type: "p",
            text:
                "O'lchanadigan to'rtta band jami oyiga taxminan 16,2 mln so'm beradi. Yiliga bu 194 mln so'm — ombor moduli narxidan qariyb besh barobar ko'p. O'z kompaniyangiz uchun jadvalni to'ldirib chiqing: raqamlar sizniki bo'ladi, formulalar o'zgarmaydi.",
        },

        { type: "h2", text: "ERP qancha turadi va qancha vaqt oladi?" },
        {
            type: "p",
            text:
                "ERP birdaniga emas, modullar bo'yicha ishga tushadi. Shuning uchun narx ham bosqichma-bosqich to'lanadi — birinchi modul ishga tushmaguncha butun summa so'ralmaydi.",
        },
        {
            type: "table",
            head: ["Tarif", "Narx (so'mdan)", "Muddat", "Nimani qamrab oladi"],
            rows: [
                [
                    "Ombor",
                    "40 000 000",
                    "8–12 hafta",
                    "Nomenklatura, kirim-chiqim, ko'p ombor, ta'minotchilar, inventarizatsiya, shtrix-kod",
                ],
                [
                    "Ishlab chiqarish",
                    "75 000 000",
                    "16–26 hafta",
                    "Ombor moduli ustiga retsept, ishlab chiqarish buyurtmasi, tannarx, moliya, 1C integratsiyasi",
                ],
                [
                    "Korporativ",
                    "Kelishuv asosida",
                    "Loyihaga qarab",
                    "HR, byudjetlashtirish, B2B portal, TSD qurilmalari, ko'p valyuta, o'z serveringizda joylashtirish",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan bandlar: server yoki bulut xarajati, odatda oyiga 500 ming so'mdan, to'g'ridan-to'g'ri provayderga to'lanadi. Shtrix-kod skaneri va TSD qurilmalari alohida sotib olinadi. Ishga tushirilgandan keyingi qo'llab-quvvatlash ham alohida hisoblanadi. Narxlarga QQS kiritilmagan.",
        },

        { type: "h2", text: "ERP qachon o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Yuqoridagi model kompaniya uchun hisob shunday chiqadi: ombor moduli 40 mln so'm, o'lchangan yo'qotish oyiga 16,2 mln so'm. Sof matematika 40 ÷ 16,2 ≈ 2,5 oy beradi, lekin bu raqam haqiqatni ko'rsatmaydi.",
        },
        {
            type: "p",
            text:
                "Sababi ikkita. Birinchidan, joriy etishning o'zi 8–12 hafta oladi va bu davrda tejamkorlik nolga teng. Ikkinchidan, tizim to'liq samara berishi uchun ma'lumot tozalanishi va jamoa o'rganishi kerak — bu yana 2–3 oy. Shuning uchun realroq qaytish muddati 6–9 oy. Aynan shu raqamni byudjet himoyasiga oling, «ikki yarim oy» emas.",
        },
        {
            type: "p",
            text:
                "Kontekst ham hisobga olinadi. 2026-yil 26-maydagi PF-100 farmoni bilan 1-iyundan QQS ga o'tish chegarasi 1 mlrd so'mdan 12 000 BHM — taxminan 5 mlrd so'mgacha ko'tarildi. Ko'p kompaniya shundan keyin o'sish rejasini kengaytirdi. O'sish esa Excel'ni birinchi bo'lib sindiradi: hajm ikki barobar oshsa, qo'lda hisob xatosi ham ikki barobar oshadi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "1C bor — unda ERP kerakmi?" },
        {
            type: "p",
            text:
                "Bu eng ko'p beriladigan savol va javob har doim ham «ha» emas. 1C buxgalteriya va reglament hisobotini yaxshi yopadi. Muammo boshqa joyda: operativ jarayonlar — ishlab chiqarish rejasi, brigadalar yuklamasi, buyurtma bosqichlari — ko'pincha 1C dan tashqarida, o'sha Excel'da qoladi.",
        },
        {
            type: "p",
            text:
                "Shuning uchun amaliyotda eng keng tarqalgan yechim — almashtirish emas, birlashtirish. 1C buxgalteriyada qoladi, operativ hisob esa yangi tizimga o'tadi, ikkalasi o'rtasida ikki tomonlama integratsiya quriladi. Nomenklatura, kontragentlar va hujjatlar avtomatik almashinadi, qo'sh kiritish yo'qoladi.",
        },
        {
            type: "p",
            text:
                "1C ni butunlay almashtirish mantiqiy bo'ladigan holat ham bor: agar u shunchalik ko'p moslashtirilgan bo'lsaki, har yangilanish loyihaga aylansa va uni faqat bitta dasturchi tushunsa. Bunday holatda bog'liqlik xavfi tejamkorlikdan katta bo'lib qoladi.",
        },

        { type: "h2", text: "ERP qachon kerak emas?" },
        {
            type: "p",
            text:
                "Loyihaning eng qimmat varianti — noto'g'ri vaqtda boshlangani. Quyidagi holatlarda ERP dan tiyilish to'g'riroq.",
        },
        {
            type: "list",
            items: [
                "Nomenklatura 200 pozitsiyadan kam va bitta ombor bor. Yaxshi tuzilgan jadval hamda kirish huquqlari yetadi.",
                "Jarayon hali o'zgarib turibdi. Yangi yo'nalish sinalayotgan bo'lsa, tizim qotib qolgan qolipga aylanadi.",
                "Asosiy muammo intizomda. Ombordor kirimni yozmasa, ERP ham uning o'rniga yozmaydi.",
                "Ichkarida loyiha egasi yo'q. ERP joriy etishda bu shart CRM'dagidan ham qat'iyroq.",
                "Byudjet faqat ishlab chiqishga yetadi. Migratsiya, o'qitish va birinchi oylardagi parallel ish alohida resurs talab qiladi.",
            ],
        },
        {
            type: "p",
            text:
                "Yana bir halol ogohlantirish: ERP tartibsizlikni tuzatmaydi. Agar hozir kim qanday hujjat yozishi kelishilmagan bo'lsa, tizim shu kelishuvsizlikni qotirib qo'yadi. Jarayonni avval qog'ozda tartibga soling.",
        },

        { type: "h2", text: "Joriy etish qanday bosqichlarda boradi" },
        {
            type: "ol",
            items: [
                "Jarayon auditi. 1–2 hafta. Hozirgi hisob qanday yuritilayotgani chiziladi va yo'qotishlar o'lchanadi.",
                "Asosiy modul. 6–10 hafta. Odatda ombor yoki sotuv — ma'lumot eng ko'p bo'lgan joy.",
                "Migratsiya va parallel ish. 3–6 hafta. Eski baza ko'chiriladi va bir muddat ikkala tizim birga ishlaydi.",
                "Kengaytirish va qo'llab-quvvatlash. Ishlab chiqarish, moliya va hisobot modullari ketma-ket qo'shiladi.",
            ],
        },
        {
            type: "p",
            text:
                "Parallel ish bosqichini o'tkazib yubormang. U qo'shimcha yuk bo'lib tuyuladi, lekin aynan shu davrda eski va yangi raqam solishtiriladi. Farq topilsa, uni ishga tushirishdan oldin tuzatish ancha arzon.",
        },
        { type: "image", image: 3 },
    ],

    faq: [
        {
            q: "Nechta signal to'g'ri kelsa, ERP haqida o'ylash kerak?",
            a: "Uchtasi to'g'ri kelsa, jarayonni tartibga solish vaqti keldi — bu hali dastur emas, reglament masalasi. Beshtasi va undan ko'pi to'g'ri kelsa, Excel endi hisob vositasi emas, xavf manbayi bo'lib qolgan. Alohida e'tibor bering: markirovka va elektron hisob-faktura qo'lda kiritilayotgan bo'lsa, bu signal yolg'iz o'zi ham yetarli.",
        },
        {
            q: "ERP joriy etish qancha vaqt oladi?",
            a: "Ombor moduli 8–12 hafta, ishlab chiqarish bilan birga 16–26 hafta. Bu faqat ishlab chiqish muddati. Unga ma'lumot tozalash, migratsiya va jamoani o'qitish qo'shiladi — amalda yana 1–2 oy. Shuning uchun birinchi suhbatdan to'liq samaragacha odatda olti oy atrofida vaqt ketadi, buni rejaga oldindan kiriting.",
        },
        {
            q: "ERP narxiga nima kirmaydi?",
            a: "Server yoki bulut xarajati alohida va to'g'ridan-to'g'ri provayderga to'lanadi, odatda oyiga 500 ming so'mdan. Shtrix-kod skaneri va ombor uchun TSD qurilmalari alohida sotib olinadi. Ishga tushirilgandan keyingi doimiy texnik qo'llab-quvvatlash ham alohida hisoblanadi. Narxlarga QQS kiritilmagan. Bu bandlarni byudjetga oldindan kiriting.",
        },
        {
            q: "1C bor bo'lsa, ERP olish shartmi?",
            a: "Shart emas. Eng keng tarqalgan yechim — 1C ni buxgalteriyada qoldirib, operativ hisobni yangi tizimga olib chiqish va ikkalasi o'rtasida ikki tomonlama integratsiya qurish. Nomenklatura, kontragentlar va hujjatlar avtomatik almashinadi. 1C ni to'liq almashtirish faqat u haddan tashqari moslashtirilgan va bitta odamga bog'lanib qolgan holatda mantiqiy.",
        },
        {
            q: "Ma'lumotni Excel'dan ko'chirib olish mumkinmi?",
            a: "Ha, lekin bu loyihaning eng ko'p vaqt oladigan qismi. Qiyinchilik faylni o'qishda emas, uni tozalashda: bir tovar uch xil nom bilan yozilgan, o'lchov birliklari aralash, qoldiqlar manfiy. Shuning uchun migratsiyani alohida bosqich sifatida rejalashtiring va nomenklaturani tartibga solishga kamida ikki hafta ajrating.",
        },
        {
            q: "Kichik kompaniyaga ERP kerakmi?",
            a: "Odatda yo'q. Nomenklatura 200 pozitsiyadan kam bo'lsa, bitta ombor bo'lsa va hisobni bir kishi yuritsa, yaxshi tuzilgan jadval yetadi. ERP haqida o'ylash uchun kamida ikkita shart kerak: bir necha kishi bir vaqtda hisob yuritishi va ma'lumotlar o'zaro bog'liq bo'lishi. Aks holda tizim ortiqcha yuk bo'lib qoladi.",
        },
    ],

    cta: {
        h: "Hisobingizni bepul tahlil qilamiz",
        p:
            "Jadvallaringizni va hozirgi hisob tartibini ko'ramiz, qaysi signallar sizda borligini va ular qancha pulga tushayotganini raqamda ko'rsatamiz. ERP hozir kerak bo'lmasa, buni ochiq aytamiz.",
        button: "Bepul tahlil so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/excel-erp-yorilgan-jadval.webp",
            alt: "Kompaniya hajmini ko'tara olmay yorilayotgan Excel jadvali va to'kilayotgan hujjatlar",
            caption: "Jadval yomon emas — u shunchaki ma'lum hajmdan keyin yoriladi",
            prompt:
                "Conceptual image: a giant spreadsheet grid visibly cracking apart at the seams, with boxes, invoices and order cards spilling out; clean editorial flat-vector, amber warning accents on blue-grey base, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/excel-erp-sakkiz-signal.webp",
            alt: "Excel'dan ERP'ga o'tish vaqti kelganini ko'rsatuvchi sakkizta signal kartochkasi",
            caption: "Sakkizta signal: uchtasi ogohlantiradi, beshtasi qaror talab qiladi",
            prompt:
                "Eight-signal checklist grid: eight cards each with a simple icon and a severity dot (yellow to red) representing stock mismatch, slow month close, duplicated data, file loss, no price history, single-person reporting, manual marking entry, order cancellations; clean flat cards, light background, no readable text, 4:3",
        },
        {
            src: "/assets/img/projects/uzfiltr.webp",
            alt: "Uzfiltr ishlab chiqarish kompaniyasi uchun ombor va ishlab chiqarish hisobi interfeysi",
            caption: "Uzfiltr: ishlab chiqarish hisobi bitta tizimga yig'ilgan",
        },
        {
            src: "/assets/img/blog/erp-joriy-etish-jadvali.webp",
            alt: "ERP joriy etishning bosqichma-bosqich jadvali: audit, modullar, migratsiya, kengaytirish",
            caption: "To'rt bosqich: audit, asosiy modul, migratsiya va parallel ish, kengaytirish",
            prompt:
                "Phased implementation timeline: four phases (process audit, core modules, data migration and parallel run, rollout and support) shown as a horizontal bar with week ranges; minimal project-plan style, blue gradient, no text placeholders, 16:9",
        },
    ],

    relatedServices: ["erp-tizimlar", "crm-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: [
        "biznes-avtomatlashtirish-yol-xaritasi",
        "tayyor-crm-yoki-oz-crm-tco",
        "telegram-bot-nimani-avtomatlashtiradi",
    ],
};

const ru = {
    meta: {
        title: "Когда переходить с Excel на ERP: 8 признаков | Innobek",
        description:
            "Когда переходить с Excel на ERP: восемь признаков того, что компания переросла таблицы, денежная оценка каждого, цена ERP и сроки поэтапного внедрения.",
        keywords: [
            "когда переходить с Excel на ERP",
            "внедрение ERP в Узбекистане",
            "учёт склада и производства программа",
            "1С или собственная ERP",
            "ошибки внедрения ERP",
            "стоимость ERP системы",
        ],
    },
    h1: "С Excel на ERP: восемь признаков того, что компания переросла таблицы",
    lead:
        "Excel — не плохой инструмент, он просто перестаёт работать после определённого объёма. В статье — восемь признаков этой границы, денежная оценка каждого из них, а также цена и сроки внедрения ERP.",
    category: "Автоматизация",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Ни одна компания не может назвать день, в который Excel перестал справляться. Переход происходит незаметно: сначала один файл делится на два, потом в каждом отделе появляется своя копия, а затем никто уже не знает, какая из копий верная. Восемь признаков ниже — этапы этого пути.",
        },

        { type: "h2", text: "До какого объёма хватает Excel?" },
        {
            type: "p",
            text:
                "Excel отлично работает, пока с одним файлом работает один человек. Проблемы начинаются, когда людей становится несколько, а данные оказываются связанными: складской остаток влияет на продажи, продажи на финансы, финансы на производство.",
        },
        {
            type: "p",
            text:
                "В таблице эти связи держатся в голове у сотрудника. Ушёл в отпуск, заболел, уволился — связи исчезли вместе с ним. ERP переносит их в программу. Иначе говоря, ERP не делает учёт лучше, она делает его независимым от конкретного человека.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Первые четыре признака: учёт начал разъезжаться" },
        {
            type: "list",
            items: [
                "Признак 1. Складской остаток не совпадает с фактом. В таблице 40 штук, на полке 33. Инвентаризация раз за разом показывает недостачу, а причина не находится.",
                "Признак 2. Закрытие месяца занимает больше недели. Бухгалтерия сводит цифры к 10–15 числу, и руководитель принимает решения по устаревшим данным.",
                "Признак 3. Одни и те же данные живут в трёх местах. Имя клиента в CRM, заказ в Excel, оплата в 1С. Когда они расходятся, доказать, какая версия верна, невозможно.",
                "Признак 4. Заказы всё чаще отменяются. Клиенту говорят «есть в наличии», а на складе товара нет. Каждый такой случай стоит одной сделки и одного клиента.",
            ],
        },
        {
            type: "p",
            text:
                "У этих четырёх признаков одна общая причина: данные существуют в нескольких копиях, и автоматической связи между копиями нет. Ручная синхронизация всегда опаздывает.",
        },

        { type: "h2", text: "Следующие четыре: управление и требования закона" },
        {
            type: "list",
            items: [
                "Признак 5. С уходом сотрудника теряется файл или знание. Если звучит фраза «эту таблицу вела Дильноза», система живёт в человеке, а не в компании.",
                "Признак 6. Нет истории цен и условий. Клиент ссылается на цену полугодовой давности, а проверить её нечем. Спор почти всегда решается не в пользу компании.",
                "Признак 7. Отчёт умеет готовить только один человек. Он занят — руководитель остаётся без цифр. Этот признак замечают позже всех, а он самый опасный.",
                "Признак 8. Маркировка и электронные счета-фактуры вводятся вручную. Ручная работа по каждому чеку и документу — это и потеря времени, и налоговый риск одновременно.",
            ],
        },
        {
            type: "p",
            text:
                "Последний признак в 2026 году стал особенно весомым. По ПП-190 от 23.05.2025 с 1 июля код маркировки должен отображаться в чеке онлайн-ККМ, а расчёты в оптовой торговле маркированным товаром проводятся только безналично, через банковские счета. С 1 сентября нарушение правил маркировки считается фактором «высокого» налогового риска. Автоматический контроль электронных счетов-фактур также усилен.",
        },
        {
            type: "callout",
            text:
                "Совпали три признака — пора наводить порядок в процессах. Совпали пять — Excel перестал быть инструментом учёта и превратился в источник риска.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Сколько стоит каждый признак в деньгах?" },
        {
            type: "p",
            text:
                "Сам по себе признак ничего не значит — его нужно перевести в деньги. В таблице взята модельная компания: оптовая торговля, 25 сотрудников, 400 заказов в месяц, средний чек 4 млн сум, маржа 15 процентов, себестоимость часа 45–50 тысяч сум.",
        },
        {
            type: "table",
            head: ["Признак", "Как измеряется", "У модельной компании в месяц"],
            rows: [
                [
                    "Отменённые заказы",
                    "Заказы, сорванные из-за ошибки остатка × средний чек × маржа",
                    "12 × 4 млн × 15% ≈ 7,2 млн сум",
                ],
                [
                    "Затянутое закрытие месяца",
                    "Часы на закрытие × себестоимость часа",
                    "80 часов × 50 000 ≈ 4 млн сум",
                ],
                [
                    "Данные в трёх местах",
                    "Часы на повторный ввод × себестоимость часа",
                    "66 часов × 45 000 ≈ 3 млн сум",
                ],
                [
                    "Ручная маркировка и ЭСФ",
                    "Часы ручного ввода × себестоимость часа плюс налоговый риск",
                    "44 часа × 45 000 ≈ 2 млн сум",
                ],
                [
                    "Складская недостача",
                    "Недостача по последнему акту инвентаризации ÷ 12",
                    "Возьмите из своего акта",
                ],
                [
                    "Отчёт на одном человеке",
                    "Число дней задержки управленческого решения",
                    "Обычно 5–10 дней, в деньгах не считается",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Четыре измеримых пункта дают около 16,2 млн сум в месяц. За год это 194 млн — почти в пять раз больше стоимости складского модуля. Заполните таблицу под свою компанию: цифры будут ваши, формулы останутся теми же.",
        },

        { type: "h2", text: "Сколько стоит ERP и сколько занимает внедрение?" },
        {
            type: "p",
            text:
                "ERP запускается не целиком, а модулями. Поэтому и оплата идёт поэтапно — всю сумму не просят до запуска первого модуля.",
        },
        {
            type: "table",
            head: ["Тариф", "Цена (от, сум)", "Срок", "Что охватывает"],
            rows: [
                [
                    "Склад",
                    "40 000 000",
                    "8–12 недель",
                    "Номенклатура, приход и расход, несколько складов, поставщики, инвентаризация, штрихкоды",
                ],
                [
                    "Производство",
                    "75 000 000",
                    "16–26 недель",
                    "Складской модуль плюс рецептуры, производственные заказы, себестоимость, финансы, интеграция с 1С",
                ],
                [
                    "Корпоративный",
                    "По договорённости",
                    "Зависит от проекта",
                    "HR, бюджетирование, B2B-портал, ТСД, мультивалютность, размещение на своём сервере",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Что не входит в цену: сервер или облако, обычно от 500 тысяч сум в месяц, оплачивается напрямую провайдеру. Сканеры штрихкодов и терминалы сбора данных покупаются отдельно. Постоянная техническая поддержка после запуска считается отдельно. НДС в цены не включён.",
        },

        { type: "h2", text: "За какой срок окупается ERP?" },
        {
            type: "p",
            text:
                "Для модельной компании расчёт такой: складской модуль стоит 40 млн сум, измеренные потери — 16,2 млн в месяц. Чистая арифметика даёт 40 ÷ 16,2 ≈ 2,5 месяца, но эта цифра не отражает реальность.",
        },
        {
            type: "p",
            text:
                "Причины две. Во-первых, само внедрение занимает 8–12 недель, и в этот период экономии нет вовсе. Во-вторых, чтобы система заработала в полную силу, нужно вычистить данные и обучить команду — это ещё 2–3 месяца. Поэтому реалистичный срок окупаемости — 6–9 месяцев. Именно эту цифру берите на защиту бюджета, а не «два с половиной месяца».",
        },
        {
            type: "p",
            text:
                "Контекст тоже играет роль. Указом ПФ-100 от 26 мая 2026 года с 1 июня порог перехода на НДС поднят с 1 млрд сум до 12 000 БРВ — около 5 млрд сум. После этого многие компании расширили планы роста, а рост первым делом ломает именно Excel: удвоился объём — удвоилось и число ошибок ручного учёта.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "У нас есть 1С — нужна ли тогда ERP?" },
        {
            type: "p",
            text:
                "Это самый частый вопрос, и ответ на него далеко не всегда утвердительный. 1С хорошо закрывает бухгалтерию и регламентную отчётность. Проблема в другом: оперативные процессы — план производства, загрузка бригад, стадии заказа — обычно остаются за её пределами, в том же Excel.",
        },
        {
            type: "p",
            text:
                "Поэтому на практике чаще всего выбирают не замену, а связку. 1С остаётся в бухгалтерии, оперативный учёт переезжает в новую систему, а между ними строится двусторонняя интеграция. Номенклатура, контрагенты и документы обмениваются автоматически, двойной ввод исчезает.",
        },
        {
            type: "p",
            text:
                "Полная замена 1С оправдана в одном случае: когда она настолько переписана под компанию, что каждое обновление превращается в проект, а разбирается в ней один-единственный программист. Тогда риск зависимости перевешивает экономию.",
        },

        { type: "h2", text: "Когда ERP не нужна?" },
        {
            type: "p",
            text:
                "Самый дорогой вариант проекта — начатый не вовремя. В перечисленных ситуациях с ERP лучше повременить.",
        },
        {
            type: "list",
            items: [
                "В номенклатуре меньше 200 позиций и один склад. Достаточно аккуратной таблицы и разграничения прав доступа.",
                "Процесс ещё меняется. Если вы тестируете новое направление, система превратится в жёсткую рамку.",
                "Основная проблема в дисциплине. Если кладовщик не оформляет приход, ERP не сделает это за него.",
                "Внутри нет владельца проекта. Во внедрении ERP это условие даже жёстче, чем в CRM.",
                "Бюджета хватает только на разработку. Миграция, обучение и параллельная работа требуют отдельного ресурса.",
            ],
        },
        {
            type: "p",
            text:
                "Ещё одно честное предупреждение: ERP не исправляет беспорядок. Если сегодня не согласовано, кто и какой документ оформляет, система лишь закрепит эту неразбериху. Сначала наведите порядок на бумаге.",
        },

        { type: "h2", text: "Как проходит внедрение по этапам" },
        {
            type: "ol",
            items: [
                "Аудит процессов. 1–2 недели. Описывается, как ведётся учёт сегодня, и измеряются потери.",
                "Основной модуль. 6–10 недель. Обычно это склад или продажи — участок с наибольшим объёмом данных.",
                "Миграция и параллельная работа. 3–6 недель. Старая база переносится, какое-то время работают обе системы.",
                "Расширение и поддержка. Последовательно добавляются производство, финансы и отчётность.",
            ],
        },
        {
            type: "p",
            text:
                "Не пропускайте этап параллельной работы. Он кажется лишней нагрузкой, но именно в этот период сверяются старые и новые цифры. Найденное расхождение дешевле исправить до запуска, чем после него.",
        },
        { type: "image", image: 3 },
    ],

    faq: [
        {
            q: "Сколько признаков должно совпасть, чтобы думать об ERP?",
            a: "Если совпали три, пора наводить порядок в процессах — это пока вопрос регламента, а не программы. Если пять и больше, Excel перестал быть инструментом учёта и стал источником риска. Отдельно отметим: если маркировка и электронные счета-фактуры вводятся вручную, одного этого признака уже достаточно для разговора.",
        },
        {
            q: "Сколько времени занимает внедрение ERP?",
            a: "Складской модуль — 8–12 недель, вместе с производством — 16–26 недель. Это только срок разработки. К нему добавляются чистка данных, миграция и обучение команды — на практике ещё один-два месяца. Поэтому от первой встречи до полного эффекта обычно проходит около полугода, и это стоит заложить в план заранее.",
        },
        {
            q: "Что не входит в стоимость ERP?",
            a: "Сервер или облако оплачивается отдельно и напрямую провайдеру, обычно от 500 тысяч сум в месяц. Сканеры штрихкодов и терминалы сбора данных для склада покупаются отдельно. Постоянная техническая поддержка после запуска считается отдельной статьёй. НДС в цены не включён. Эти позиции лучше внести в бюджет заранее.",
        },
        {
            q: "Если есть 1С, обязательно ли брать ERP?",
            a: "Не обязательно. Самое распространённое решение — оставить 1С в бухгалтерии, вынести оперативный учёт в новую систему и построить между ними двусторонний обмен. Номенклатура, контрагенты и документы синхронизируются автоматически. Полная замена 1С оправдана только тогда, когда она сильно переписана и держится на одном специалисте.",
        },
        {
            q: "Можно ли перенести данные из Excel?",
            a: "Да, но это самая трудоёмкая часть проекта. Сложность не в чтении файла, а в чистке: один товар записан под тремя названиями, единицы измерения перепутаны, остатки уходят в минус. Поэтому планируйте миграцию как отдельный этап и закладывайте минимум две недели на приведение номенклатуры в порядок.",
        },
        {
            q: "Нужна ли ERP небольшой компании?",
            a: "Как правило, нет. Если в номенклатуре меньше 200 позиций, склад один, а учёт ведёт один человек, достаточно аккуратной таблицы. Чтобы думать об ERP, нужны минимум два условия: учёт ведут несколько человек одновременно и данные связаны между собой. Без них система станет лишней нагрузкой на команду.",
        },
    ],

    cta: {
        h: "Бесплатно разберём ваш учёт",
        p:
            "Посмотрим ваши таблицы и текущий порядок учёта, покажем, какие признаки уже проявились и во сколько они обходятся в деньгах. Если ERP вам пока не нужна, скажем об этом прямо.",
        button: "Запросить бесплатный анализ",
    },

    images: [
        {
            src: "/assets/img/blog/excel-erp-yorilgan-jadval.webp",
            alt: "Электронная таблица, не выдерживающая объёма компании, и рассыпающиеся документы",
            caption: "Таблица не плоха — она просто трескается после определённого объёма",
            prompt:
                "Conceptual image: a giant spreadsheet grid visibly cracking apart at the seams, with boxes, invoices and order cards spilling out; clean editorial flat-vector, amber warning accents on blue-grey base, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/excel-erp-sakkiz-signal.webp",
            alt: "Восемь карточек-признаков того, что пора переходить с Excel на ERP",
            caption: "Восемь признаков: три предупреждают, пять требуют решения",
            prompt:
                "Eight-signal checklist grid: eight cards each with a simple icon and a severity dot (yellow to red) representing stock mismatch, slow month close, duplicated data, file loss, no price history, single-person reporting, manual marking entry, order cancellations; clean flat cards, light background, no readable text, 4:3",
        },
        {
            src: "/assets/img/projects/uzfiltr.webp",
            alt: "Интерфейс складского и производственного учёта для компании Uzfiltr",
            caption: "Uzfiltr: производственный учёт собран в одной системе",
        },
        {
            src: "/assets/img/blog/erp-joriy-etish-jadvali.webp",
            alt: "Поэтапный график внедрения ERP: аудит, модули, миграция, расширение",
            caption: "Четыре этапа: аудит, основной модуль, миграция и параллельный запуск, расширение",
            prompt:
                "Phased implementation timeline: four phases (process audit, core modules, data migration and parallel run, rollout and support) shown as a horizontal bar with week ranges; minimal project-plan style, blue gradient, no text placeholders, 16:9",
        },
    ],

    relatedServices: ["erp-tizimlar", "crm-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: [
        "biznes-avtomatlashtirish-yol-xaritasi",
        "tayyor-crm-yoki-oz-crm-tco",
        "telegram-bot-nimani-avtomatlashtiradi",
    ],
};

const content = { uz, ru };

export default content;
